var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 10.309,
    viewBox: "0 0 12.5 10.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#E10092;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.75 1.061)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.5,18h11",
    transform: "translate(-7.5 -13.931)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.524,8.931,23.5,13l-3.976,4.119",
    transform: "translate(-12.5 -8.931)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBlue);
export default __webpack_public_path__ + "static/media/right-arrow-blue.6b7cada3ea5a7e5213258fbd3576e6af.svg";
export { ForwardRef as ReactComponent };